import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../../services';
import { AuthUser } from '../../types';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireAdmin = true,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        console.log('ProtectedRoute: Checking auth...');
        const user = await authService.getCurrentUser();
        console.log('ProtectedRoute: Current user:', user);

        if (!user) {
          console.log('ProtectedRoute: No user found, unauthorized');
          setIsAuthorized(false);
          setIsLoading(false);
          return;
        }

        if (requireAdmin && !user.groups.includes('Admins')) {
          console.log('ProtectedRoute: User not in Admins group:', user.groups);
          setIsAuthorized(false);
          setIsLoading(false);
          return;
        }

        console.log('ProtectedRoute: Auth check passed, user is authorized');
        setIsAuthorized(true);
      } catch (error) {
        console.error('Auth check failed:', error);
        setIsAuthorized(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, [requireAdmin]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!isAuthorized) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};
